import React,{useState,useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
export default function CourseCard({id,name,image,path}) {
    const [lan, setLan] = useState('bangla')
    const navigator = useNavigate()
    const switchPath = (pathname) => {
        navigator(pathname)
    }
    useEffect(() => {
        if (localStorage.getItem('language') === 'english') {
        setLan('english')
        } else {
        setLan('bangla')
        }
  }, [])
    return (
        <div class="items-center py-8 px-4 ">
            <div class="max-w-sm bg-white border border-gray-500 rounded-lg shadow-lg dark:bg-gray-700 dark:border-gray-700">
                {lan=="english" && <h5 class="mt-4 text-2xl text-center font-bold tracking-tight text-gray-900 dark:text-white">TRACK {id}</h5>}
                {lan=="bangla" && <h5 class="mt-4 text-2xl text-center font-bold tracking-tight text-gray-900 dark:text-white">ট্র্যাক {id}</h5>}
                <h5 class="mb-4 text-3xl text-center font-bold tracking-tight text-gray-900 text-primary-500">{name}</h5>

                <img class="w-full" src={image} alt="" />

                <div className="w-full flex items-center justify-center">
                    <a href="#" onClick={() => switchPath(`/courses/${path}`)} class="inline-flex my-8  text-center items-center text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900">
                        {lan=="english" && <h5 class="text-lg text-center font-bold tracking-tight text-gray-900 text-white">Get Started</h5>}
                        {lan=="bangla" && <h5 class="text-lg text-center font-bold tracking-tight text-gray-900 text-white">শুরু করো</h5>}
                    </a>
                </div>
            </div>
        </div>
          
  )
}
